import { IApplicationState } from 'setup/store'

export const selectBonusHistory = (state: IApplicationState) => state.bonusHistory.data.bonusHistory
export const selectBonusHistoryComm = (state: IApplicationState) => state.bonusHistory.communications

export const selectCashbackHistory = (state: IApplicationState) => state.bonusHistory.data.cashbackHistory
